import { render, staticRenderFns } from "./staffadvances.vue?vue&type=template&id=6907a103&"
import script from "./staffadvances.vue?vue&type=script&lang=js&"
export * from "./staffadvances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports